
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"times-o_svg__a","maskUnits":"userSpaceOnUse","x":"9","y":"9","width":"18","height":"18"}},[_c('path',{attrs:{"d":"M19.856 18l6.098-6.098a.563.563 0 000-.797l-1.059-1.06a.563.563 0 00-.797 0L18 16.144 11.9 10.045a.563.563 0 00-.796 0l-1.06 1.06a.563.563 0 000 .797L16.144 18l-6.099 6.099a.563.563 0 000 .796l1.06 1.06c.22.22.576.22.796 0L18 19.856l6.098 6.099c.22.22.577.22.797 0l1.06-1.06a.563.563 0 000-.796L19.855 18z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#times-o_svg__a)"}},[_c('path',{attrs:{"fill":"#FF5F3C","d":"M0 0h36v36H0z"}})])])
          )
        }
      }
    